import createFileTree from 'pretty-file-tree'
import { createExecutableFromProject, createProjectStructure } from '../services/loading-files.js'
import { chalk } from '../utils/colors.js'
import path from 'path'
import ora from 'ora'

import fs from 'fs'

export function load(line) {
  // Get filename
  let fn = (line.split(' ')[1] || '').replace(/^("|')|("|')$/g, '')
  if (/\.lua$/.test(fn)) {
    let filePath = fn
    if (!path.isAbsolute(filePath)) {
      filePath = path.resolve(path.join(process.cwd(), fn))
    }
    if (!fs.existsSync(filePath)) {
      throw Error(chalk.red('ERROR (200): file not found.'))
    }
    console.log(chalk.green('Loading... ', fn))

    const spinner = ora({
      spinner: 'dots',
      suffixText: ``,
      discardStdin: false
    })
    spinner.start()
    spinner.suffixText = chalk.gray('Parsing project structure...')

    const projectStructure = createProjectStructure(filePath)

    const [executable, modules] = createExecutableFromProject(projectStructure)
    line = executable
    spinner.stop()

    if (projectStructure.length > 0) {
      console.log(chalk.yellow('\nThe following files will be deployed:'))
      console.log(
        createFileTree(
          projectStructure.map(mod => {
            return mod.path === filePath
              ? `${mod.path}  MAIN`
              : mod.path
          })
        )
      )
    }

    return [line, modules]
  } else {
    throw Error(chalk.red('ERROR: .load function requires a *.lua file'))
  }
}
